import PageManager from './page-manager';

export default class OrderComplete extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/order-complete.js